import React, { useState, useEffect, useRef } from "react";
import "./style.sass";
import $ from "jquery";
import HistorySearch from "components/HistorySearch";
import { decodeStorage, removeStorage } from "functions/storageBase64";
import { useIsMobile } from "hooks/useIsMobile";
import { useHistory } from "react-router-dom";
import { AutocompleteComponent } from 'components/SearchHeader';
import getSearch from 'services/getSearchAutocomplete';

export function SearchHeaderMobile({ ...props }) {
    const history = useHistory();

    const url = history.location.pathname;
    const urlSearchM = history.location.search;
    const { isMobile } = useIsMobile();
    const [typeSearch, setTypeSearch] = useState("");
    const [autocomplete, setAutocomplete] = useState([]);
    const [show, setShow] = useState(false);
    const [totalArray, setTotalArray] = useState([]);
    const [palabraBuscada, setPalabraBuscada] = useState("");
    const [, setMostrarHistorial] = useState(false);
    const [, setEnFocus] = useState(false);
    const [inputVacio, setInputVacio] = useState(false);
    var arrayBusquedas = decodeStorage("busquedas");

     useEffect(() => {
        if (typeSearch.trim().length < 3) {
            setAutocomplete([]);
            return;
        }

        let active = true;
        const timer = setTimeout(() => {
            getSearch({ typeSearch }).then(result => {
                if (active) setAutocomplete(result?.suggestions || []);
            });
        }, 250);

        return () => {
            active = false;
            clearTimeout(timer);
        };
    }, [typeSearch]);

    // buscar texto con con boton buscar
    const SearchText = (evt) => {
        evt.preventDefault();
        if (typeSearch.trim().length > 2) {
            window.location.assign(`/resultados?query=${encodeURIComponent(typeSearch.trim())}`);
        }
    };

    // ajuste de iOS
    useEffect(()=>{
        let busqueda = decodeURI(urlSearchM?.split('?search=')[1])

        if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            //console.log(urlSearchM?.split('?search=')[1])
            if(String(busqueda) !==  "undefined"){
                window.location.href = `/resultados?query=${encodeURIComponent(String(busqueda))}`;
            }
        }

    },[typeSearch, url])

    // asignar valor al input
    const SearchChange = (evt) => {
        let limpiarTexto = String(evt.target.value).trim();
        if (limpiarTexto?.length > 0) {
            setTypeSearch(String(evt.target.value));
        }
        else{
            setTypeSearch("");
        }
    };

    useEffect(() => {
        const arrayTotalCoincidencia = [];
        const total = [];

        if (autocomplete?.length > 0) {
            autocomplete.map((auto, i) => {
                return auto.clase === "word_item" && arrayTotalCoincidencia?.length < 8
                    ? arrayTotalCoincidencia.push({
                        clase: auto.clase,
                        nombre: auto.nombre,
                    })
                    : null;
            });
        }

        // if (autocomplete?.length > 0) {
        //     var contadorCate = [];
        //     autocomplete.map((auto, i) => {
        //         return auto.clase === "category_item"
        //             ? contadorCate.push(auto.clase)
        //             : null;
        //     });

        //     if (contadorCate?.length > 0)
        //         arrayTotalCoincidencia.push({
        //             clase: "disclaimerNotice",
        //             nombre: "Por categoría",
        //         });

        //     autocomplete.map((auto, i) => {
        //         return auto.clase === "category_item" &&
        //             arrayTotalCoincidencia?.length < 9
        //             ? arrayTotalCoincidencia.push({
        //                 clase: auto.clase,
        //                 nombre: auto.nombre,
        //             })
        //             : null;
        //     });
        // }

        // if (autocomplete?.length > 0) {
        //     var contadorStore = [];
        //     autocomplete.map((auto, i) => {
        //         return auto.clase === "store_item"
        //             ? contadorStore.push(auto.clase)
        //             : null;
        //     });

        //     if (contadorStore?.length > 0)
        //         arrayTotalCoincidencia.push({
        //             clase: "disclaimerNotice",
        //             nombre: "Por tienda",
        //         });

        //     autocomplete.map((auto, i) => {
        //         return auto.clase === "store_item" &&
        //             arrayTotalCoincidencia?.length <= 10
        //             ? arrayTotalCoincidencia.push({
        //                 clase: auto.clase,
        //                 nombre: auto.nombre,
        //             })
        //             : null;
        //     });
        // }

        total.push(arrayTotalCoincidencia);
        setTotalArray(total[0]);
    }, [autocomplete]);

    const ClearTextLink = (text) => {
        const texto = text;
        const limpio1 = texto.replace(/(<([^>]+)>)/gi, "").trim();
        const longitud = limpio1?.length;

        // if (limpio1.substring(0, 14) === "Ir a la Tienda") {
        //     return <p>{limpio1.substring(15, longitud)}</p>;
        // }
        if (limpio1.substring(0, 17) === "Ir a la Categoría") {
            return <p>{limpio1.substring(18, longitud)}</p>;
        }
        return texto.replace(/(<([^>]+)>)/gi, "").trim();
    };

    function ClearTextLink2(text) {
        const texto = text;

        const limpio2 = texto.replace(/(<([^>]+)>)/gi, "").trim();
        const longitud = limpio2?.length;

        // if (limpio2.substring(0, 14) == "Ir a la Tienda") {
        //     return limpio2.substring(15, longitud).trim();
        // } else 
        if (limpio2.trim().substring(0, 15) == "Ir a la Categor") {
            return limpio2.substring(18, longitud).trim();
        }

        return texto.replace(/(<([^>]+)>)/gi, "").trim();
    }

    //- Funcion de la respuesta del autocompletado para mandar a la busqueda
    const hiddenAutocomplete = (e) => {
        enviarPalabraBuscada(e);
        setAutocomplete([]);

        var buscarTexto = String(e.target.value);
        var urlRedirigir = `/resultados?query=${encodeURIComponent(buscarTexto.trim())}`;

        setTypeSearch(buscarTexto);
        setTimeout(() => {
            window.location.assign(urlRedirigir);
        }, 300);
    };

    function enviarPalabraBuscada(evt) {
        evt.preventDefault();

        if (String(evt.target.value) != "") {
            //setPalabraBuscada(String(evt.target.value).replace("%",""));
            setPalabraBuscada(String(evt.target.value))
            console.log('5')
        }
    }

    const guardarTexto = (e) => {
        enviarPalabraBuscada(e);

        setTimeout(() => {
            if (typeSearch.trim().length > 2) {
                window.location.assign(`/resultados?query=${encodeURIComponent(typeSearch.trim())}`);
            }
        }, 500);
    };

    const [movimientoSubirBajar, setMovimientoSubirBajar] = useState(0);

    const handleKeyMove = (evt) => {
        removeStorage('searchBusqueda')
        if (evt.keyCode == 38) {
            if (movimientoSubirBajar > 0)
                setMovimientoSubirBajar(movimientoSubirBajar - 1);
        } else if (evt.keyCode == 40) {
            setMovimientoSubirBajar(movimientoSubirBajar + 1);
        }
    };
    //----------------------------------------------------------

    useEffect(() => {
        const handleMouseDown = event => {
            if (show && !event.target.closest('.moduleSearchAutocomplete')) {
                setShow(false);
            }
        };

        document.addEventListener("mousedown", handleMouseDown);
        return () => document.removeEventListener("mousedown", handleMouseDown);
    }, [show]);

    const handleFocusSearcherInput = () => {
        setShow(true);
        removeStorage('searchBusqueda')
    }

    const handleBlurSearcherInput = () => {
        setTimeout(function () {
            setShow(false);
        }, 500);
    };
    useEffect(() => {
        if (show) {
            setMostrarHistorial(true);
            if (url !== "/buscador") {
                document
                    .querySelector(".headerSup form.search")
                    .classList.add("searchFocus");
            } else {
                document.querySelector("form.search").classList.add("searchFocus");
            }
        } else {
            setMostrarHistorial(false);
            if (url !== "/buscador") {
                document
                    .querySelector(".headerSup form.search")
                    .classList.remove("searchFocus");
            } else {
                document.querySelector("form.search").classList.add("searchFocus");
            }
        }
    }, [show]);

    const handleSearcherInputKeyDown = (event) => {
        removeStorage('searchBusqueda')
        if (show) {
            // use keyboard to select the suggesions
            handleSelectSuggestions(event);
        } else {
            // just show the suggestions list
            setShow(true);
        }
    };

    // use teclados para seleccionar las sugerencias
    const handleSelectSuggestions = (event) => {
        let li = $(".searcher-suggs-word.selected");
        let tienda = "Por tienda";
        let categoria = "Por categoría";

        if (event.key === 'Escape') {
            event.preventDefault();
            li.removeClass('selected');
            setShow(false);
        } else if (event.keyCode == 40 || event.keyCode == 38) {
            // 40 => down, 38 => up
            event.preventDefault();

            if (li?.length == 0) {
                $(".searcher-suggs-word:first-child").toggleClass("selected");
            } else if (event.keyCode == 40) {
                if (
                    String(li.text()).trim() == tienda ||
                    String(li.text()).trim() == categoria
                ) {
                    li.removeClass("selected");
                    li.next().addClass("selected");
                } else {
                    li.removeClass("selected");
                    li.next().addClass("selected");
                }
            } else {
                if (
                    String(li.text()).trim() === tienda ||
                    String(li.text()).trim() === categoria
                ) {
                    li.removeClass("selected");
                    li.prev().addClass("selected");
                } else {
                    li.removeClass("selected");
                    li.prev().toggleClass("selected");
                }
            }
        } else {
            if (
                String(li.text()).trim() !== tienda &&
                String(li.text()).trim() !== categoria
                ) {
                if (event.keyCode === 13 && li.length > 0) {
                    event.preventDefault();
                    const selectedQuery = String(li.find('button').val() || li.text()).trim();
                    if (selectedQuery) {
                        setTypeSearch(selectedQuery);
                        setPalabraBuscada(selectedQuery);
                        setShow(false);
                        window.location.assign(`/resultados?query=${encodeURIComponent(selectedQuery)}`);
                    }
                }
            } else {
                if (event.keyCode == 13) {
                    event.preventDefault();
                }
            }
        }
    };

    // evento flotante en la lista de sugerencias
    const handleHoverSearcherSuggestions = () => {
        $(".searcher-suggs-word.selected").removeClass("selected");
        $(".searcher-suggs-word:focus").removeClass("selected");
        $(".searcher-suggs-word:hover").addClass("selected");
    };

    function regresar() {
        history.go(-1);
    }

    // saber si el input esta limpio / vacio
    useEffect(() => {
        var elemento = document.getElementById("inputBusqueda").value;

        if (elemento == "") {
            setInputVacio(true);
        } else {
            setInputVacio(false);
        }
    });

    function focus() {
        if (document.activeElement.name === "search") {
            setEnFocus(true);
        } else {
            setEnFocus(false);
        }
    }

    // agrega el valor de la palabra seleccionada en el input de busqueda
    const ReplicarEnBuscador = (e) => {
        e.preventDefault();
        var valor = String(e.target.value).replace("%","");
        console.log('8')
        setTypeSearch(valor);
        
    };

    const nameInput = useRef();
    useEffect(() => {
        if (isMobile != "desktop") {
            nameInput.current.focus();
        }
    }, []);

    return (
        <div className="moduleSearchAutocomplete mobileComponent">
            <form onSubmit={SearchText} className="search">
                <div className="searchMobileComponent">
                    <div onClick={regresar} className="searchBack"></div>
                    <label className="line">
                        <input
                            type="search"
                            value={typeSearch}
                            className="input"
                            onChange={SearchChange}
                            //onKeyDown={handleKeyMove}
                            onKeyDown={handleSearcherInputKeyDown}
                            onFocus={handleFocusSearcherInput}
                            onBlur={handleBlurSearcherInput}
                            name="search"
                            placeholder="Buscar en Sears"
                            aria-label="Campo de busqueda"
                            autoComplete="off"
                            id="inputBusqueda"
                            ref={nameInput}
                        />
                    </label>
                    <button
                        className="btn rojo button"
                        value={typeSearch}
                        onClick={(e) => guardarTexto(e)}
                        aria-label="boton buscar"
                    >
                        Buscar
          </button>
                </div>

                <div className="listado"> 
                {/* style={{ display: "none" }}> */}
                    <HistorySearch
                        buscar={show}
                        sebusco={palabraBuscada}
                        setTypeSearch={setTypeSearch}
                        onFocus={focus}
                        name="historial"
                    />
                </div>

                {isMobile
                    ? (isMobile !== "desktop" && isMobile !== "mobile"
                        ? (autocomplete &&
                            (<ul className="contAutocomplete" onFocus={focus} name="sugerencias" >
                                {totalArray.map(({ clase, nombre }, ind) => (
                                    <li key={ind} className="searcher-suggs-word" onMouseOver={handleHoverSearcherSuggestions} >
                                        {clase === "word_item" ? (
                                            <>
                                                <button
                                                    onClick={hiddenAutocomplete}
                                                    id={`/resultados?query=${encodeURIComponent(ClearTextLink(nombre))}`}
                                                    className={clase}
                                                    value={ClearTextLink(nombre)}
                                                    aria-label="palabra a buscar"
                                                >
                                                    {ClearTextLink(nombre)}
                                                </button>
                                                {/* <button
                                                    className="ir"
                                                    onClick={(e) => ReplicarEnBuscador(e)}
                                                    value={ClearTextLink(nombre)}
                                                    aria-label="ir a"
                                                ></button> */}
                                            </>
                                        ) 
                                        // : clase === "category_item" ? (
                                        //     <>
                                        //         <button
                                        //             className={clase}
                                        //             onClick={hiddenAutocomplete}
                                        //             value={ClearTextLink2(nombre)}
                                        //             id={`/categoria/${nombre.split("/")[2]}/${nombre.split("/")[3]}`}
                                        //             aria-label="palabra a buscar"
                                        //         >
                                        //             {ClearTextLink2(nombre)}
                                        //         </button>
                                        //         {/* <button
                                        //             className="ir"
                                        //             onClick={ReplicarEnBuscador}
                                        //             value={ClearTextLink2(nombre)}
                                        //             aria-label="ir a"
                                        //         ></button> */}
                                        //     </>
                                        // ) 
                                        // : clase === "store_item" ? (
                                        //     <>
                                        //         <button
                                        //             className={clase}
                                        //             onClick={hiddenAutocomplete}
                                        //             value={ClearTextLink2(nombre)}
                                        //             id={`/tienda/${nombre.split("/")[2]}/${nombre.split("/")[3]}`}
                                        //             aria-label="palabra a buscar"
                                        //         >
                                        //             {ClearTextLink2(nombre)}
                                        //         </button>
                                        //         <button
                                        //             className="ir"
                                        //             onClick={ReplicarEnBuscador}
                                        //             value={ClearTextLink2(nombre)}
                                        //             aria-label="ir a"
                                        //         ></button>
                                        //     </>
                                        // )
                                         : clase === "disclaimerNotice"
                                            ? <span className={clase}>{ClearTextLink(nombre)} </span>
                                            : null
                                        }
                                    </li>
                                ))}
                            </ul>
                            )
                        ) : arrayBusquedas?.length > 0 && inputVacio === true
                            ? <HistorySearch buscar={show} sebusco={palabraBuscada} setTypeSearch={setTypeSearch} name="historial" />
                            : (autocomplete &&
                                <AutocompleteComponent
                                    totalArray={autocomplete}
                                    focus={focus}
                                    handleHoverSearcherSuggestions={handleHoverSearcherSuggestions}
                                    hiddenAutocomplete={hiddenAutocomplete}
                                    ClearTextLink={ClearTextLink}
                                    ClearTextLink2={ClearTextLink2}
                                    ReplicarEnBuscador={ReplicarEnBuscador}
                                />
                            )
                    ) : null
                }
            </form>
        </div>
    );
}
